import { createSelector } from "reselect";

const selectReport = (state) => state.reports;
const selectGemeinde = (state) =>
  state.gemeinde ? state.gemeinde.gemeinde : null;
const selectCurrentUser = (state) =>
  state.user ? state.user.currentUser : null;

export const selectReportsForPreview = createSelector(
  [selectReport, selectGemeinde],
  (report, gemeinde) =>
    report.items
      ? report.items.filter(
          (r) =>
            !r.geloescht &&
            ((r.freigabe && (r.oeffentlich || gemeinde)) ||
              (gemeinde && r.gemeindeId === gemeinde.id))
        )
      : null
);

export const selectGemeindeReports = createSelector(
  [selectReport, selectGemeinde],
  (report, gemeinde) => {
    return report.items && gemeinde
      ? report.items.filter((r) => !r.geloescht && r.gemeindeId === gemeinde.id)
      : null;
  }
);

export const selectCurrentReport = createSelector([selectReport], (report) => {
  return report.currentReport;
});

export const selectCurrentUserRating = createSelector(
  [selectReport],
  (report) => {
    return report.currentUserRating;
  }
);
export const selectIsReportsLoading = createSelector(
  [selectReport],
  (report) => {
    return report.loading || !!!report.items;
  }
);
export const selectCurrentReportIsLoading = createSelector(
  [selectReport],
  (report) => {
    return !!!report.currentReport;
  }
);
export const isReportRateable = createSelector(
  [selectCurrentReport, selectCurrentUser],
  (report, user) => {
    if (!!!user || !!!report) {
      return false;
    }
    if (!report.freigabe) {
      return false;
    }
    if (user.gemeindeRef.id === report.gemeindeId) {
      return false;
    }
    if (report.bewertungsende.toDate() < new Date()) {
      return false;
    }
    return true;
  }
);
